import Vue from 'vue'
import Vuex from 'vuex'
import current from './current'
import indicator from './indicator'
import report from './report'
import app from './app'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    current,
    indicator,
    report,
    app
  }
})
